import React, { useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const BlogCards = () => {
   const [currentPage, setCurrentPage] = useState(1);

   const blogPosts = [
      {
         id: 1,
         image: '/blog-list/big/1.png',
         category: 'EDUCATION',
         title: 'Eco-Education in Our Lives: We Can Change the Future',
         excerpt: 'Our features, journey, tips and us being us. Lorem ipsum dolor sit amet, accumsan in, tempor dictum neque.',
      },
      {
         id: 2,
         image: '/blog-list/big/2.png',
         category: 'EDUCATION',
         title: '8 great design trends that are making a come-back in 2021',
         excerpt: 'Our features, journey, tips and us being us. Lorem ipsum dolor sit amet, accumsan in, tempor dictum neque.',
      },
      {
         id: 3,
         image: '/blog-list/big/3.png',
         category: 'EDUCATION',
         title: '19 ways to optimize your ad marketing budget efficiently',
         excerpt: 'Our features, journey, tips and us being us. Lorem ipsum dolor sit amet, accumsan in, tempor dictum neque.',
      },
      {
         id: 4,
         image: '/blog-list/big/4.png',
         category: 'EDUCATION',
         title: '8 interesting programming languages you should be paying attention to',
         excerpt: 'Our features, journey, tips and us being us. Lorem ipsum dolor sit amet, accumsan in, tempor dictum neque.',
      },
   ];

   return (
      <section className="py-12 md:py-16 lg:py-20">
         <div className="container mx-auto px-4">
            <div className="flex flex-col items-center gap-8">
               {blogPosts.map((post) => (
                  <div key={post.id} className="w-full max-w-5xl">
                     <div className="flex flex-col lg:flex-row gap-8 bg-white rounded-lg overflow-hidden
                     dark:bg-dark-2">
                        <div className="lg:w-1/2">
                           <img
                              src={post.image}
                              alt="Blog post"
                              className="w-full h-full object-cover rounded-lg"
                           />
                        </div>

                        <div className="lg:w-1/2 p-8 lg:pl-12 md:p-10">
                           <a href="#" className="text-sm font-medium text-purple-1">
                              {post.category}
                           </a>
                           <h3 className="text-xl md:text-2xl font-medium text-gray-800 mt-4 dark:text-white">
                              {post.title}
                           </h3>
                           <p className="text-gray-500 text-sm mt-5 dark:text-gray-400">
                              {post.excerpt}
                           </p>
                           <div className="mt-6">
                              <a
                                 href="#"
                                 className="inline-block px-6 py-2 text-sm font-medium text-purple-1 border bg-light-2
                      border-light-2 rounded-lg hover:bg-purple-1 hover:text-white transition-colors
                      hover:border-purple-1"
                              >
                                 Read More
                              </a>
                           </div>
                        </div>
                     </div>
                  </div>
               ))}
            </div>

            <div className="flex justify-center mt-12">
               <nav className="flex items-center gap-4">
                  <button className="p-3 rounded-full bg-light-2 cursor-pointer">
                     <FiChevronLeft className="text-dark-1 dark:text-gray-400" />
                  </button>

                  <div className="flex gap-4">
                     <button
                        className={`w-8 h-8 rounded-full ${currentPage === 1 ? 'bg-purple-1 text-white' :
                           'hover:bg-gray-200 dark:hover:bg-gray-700'}`}
                        onClick={() => setCurrentPage(1)}
                     >
                        1
                     </button>
                     <button
                        className={`w-8 h-8 rounded-full ${currentPage === 2 ? 'bg-purple-1 text-white' :
                           'hover:bg-gray-200 dark:hover:bg-gray-700'}`}
                        onClick={() => setCurrentPage(2)}
                     >
                        2
                     </button>
                     <button
                        className={`w-8 h-8 rounded-full ${currentPage === 3 ? 'bg-purple-1 text-white' : 'hover:bg-gray-200 dark:hover:bg-gray-700'}`}
                        onClick={() => setCurrentPage(3)}
                     >
                        3
                     </button>
                     <span className="flex items-end px-1">...</span>
                     <button
                        className={`w-8 h-8 rounded-full ${currentPage === 67 ? 'bg-purple-1 text-white' : 'hover:bg-gray-200 dark:hover:bg-gray-700'}`}
                        onClick={() => setCurrentPage(67)}
                     >
                        67
                     </button>
                  </div>

                  <button className="p-3 rounded-full bg-light-2 cursor-pointer">
                     <FiChevronRight className="text-dark-1 dark:text-gray-400" />
                  </button>
               </nav>
            </div>
         </div>
      </section>
   );
};

export default BlogCards;